import { useState, useEffect } from "react";
import moment from "moment";
import { format } from "date-fns";

const Header = () => {
  const crmUser = JSON.parse(localStorage.getItem('crmUser')) || {};
  const [sidebarOpen, setSidebarOpen] = useState(false);

  const checkLogin = () => {
    if (crmUser && crmUser.user_department === 'Sales' && crmUser.last_login) {
      const today = format(new Date(), 'yyyy-MM-dd');
      const lastLogin = format(new Date(crmUser.last_login), 'yyyy-MM-dd');
      if (today !== lastLogin) {
        window.location.href = '/logout';
      }
    }
  };

  const toggleSidebar = () => {
    const sidebar = document.getElementById('side-bar');
    if (!sidebar) return;
    const isOpen = sidebar.classList.contains('sidebar-mobile-open');
    sidebar.classList.toggle('sidebar-mobile-open');
    setSidebarOpen(!isOpen);
  };

  useEffect(() => {
    checkLogin();
  }, []);

  const [clock, setClock] = useState(moment().format('dddd, D MMMM YYYY HH:mm:ss'));

  useEffect(() => {
    const interval = setInterval(() => {
      setClock(moment().format('dddd, D MMMM YYYY HH:mm:ss'));
    }, 1000);
    return () => clearInterval(interval);
  }, []);

  return (
    <>
      {sidebarOpen && (
        <div
          className="d-md-none position-fixed top-0 start-0 w-100 h-100"
          style={{ background: 'rgba(0,0,0,0.45)', zIndex: 1040 }}
          onClick={toggleSidebar}
        />
      )}
      <div className="d-flex align-items-center justify-content-between p-4 h-45">
        <div className="d-md-block d-none">
          <span className="title">{clock}</span>
        </div>
        <div className="d-md-none d-sm-block">
          <button className="btn btn-link p-0" onClick={toggleSidebar}>
            <i className={`bi ${sidebarOpen ? 'bi-x-lg' : 'bi-list'} fs-5`} />
          </button>
        </div>
        <div className="d-flex align-items-center">
          <a href="/profile">
            <p className="text-end me-2 mb-0">
              <strong className="title">{crmUser.full_name}</strong>
              <br />
              <span className="text-muted">{crmUser.user_department}</span>
            </p>
          </a>
          <a href="/profile"><img className="rounded-circle" src={crmUser.profile_picture} width={30} alt={crmUser.full_name} referrerPolicy="no-referrer" /></a>
        </div>
      </div>
    </>
  );
};

export default Header;